/**
 * @generated SignedSource<<4837913ffafab029e39a847c08854bd2>>
 * @relayHash 3c2876ad5e55d6cbc22d8c2364545212
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 24efc603e3e4e36ed538cb98b96c7342b5e4bf5ea74a1537f49bbdcc116d2833

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JsmProjectMenuContent_SidebarQuery$variables = {
  cloudId: string;
  projectId: string;
};
export type JsmProjectMenuContent_SidebarQuery$data = {
  readonly jira_projectLevelSidebarMenuCustomization: {
    readonly hiddenMenuItems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly itemId: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  };
};
export type JsmProjectMenuContent_SidebarQuery = {
  response: JsmProjectMenuContent_SidebarQuery$data;
  variables: JsmProjectMenuContent_SidebarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "projectId",
    "variableName": "projectId"
  }
],
v3 = {
  "concreteType": "JiraProjectLevelSidebarMenuItemConnection",
  "kind": "LinkedField",
  "name": "hiddenMenuItems",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraProjectLevelSidebarMenuItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraProjectLevelSidebarMenuItem",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "itemId"
            }
          ]
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "JsmProjectMenuContent_SidebarQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v2/*: any*/),
          "concreteType": "JiraProjectLevelSidebarMenuCustomization",
          "kind": "LinkedField",
          "name": "jira_projectLevelSidebarMenuCustomization",
          "plural": false,
          "selections": [
            (v3/*: any*/)
          ]
        },
        "action": "THROW",
        "path": "jira_projectLevelSidebarMenuCustomization"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "JsmProjectMenuContent_SidebarQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "JiraProjectLevelSidebarMenuCustomization",
        "kind": "LinkedField",
        "name": "jira_projectLevelSidebarMenuCustomization",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "24efc603e3e4e36ed538cb98b96c7342b5e4bf5ea74a1537f49bbdcc116d2833",
    "metadata": {},
    "name": "JsmProjectMenuContent_SidebarQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "08952bab80e03733986d0678363b31e9";

export default node;
